import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, Megaphone, LifeBuoy, MapPin, FileText, LogOut, WifiOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo, useOnline } from "@/components/shared";
import { toast } from "sonner";

const NAV = [
  { icon: LayoutDashboard, label: "Dashboard", to: "/leader" },
  { icon: Users, label: "Participants", to: "/leader/participants" },
  { icon: Megaphone, label: "Communications", to: "/leader/communications" },
  { icon: LifeBuoy, label: "Help Requests", to: "/leader/help" },
  { icon: MapPin, label: "Safe Points", to: "/leader/safe-points" },
  { icon: FileText, label: "Reports", to: "/leader/reports" },
];

export default function LeaderLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, logout } = useAuth();
  const online = useOnline();

  return (
    <div className="min-h-screen flex" style={{ background: "var(--cs-bg)" }}>
      {/* sidebar */}
      <aside className="hidden lg:flex flex-col w-64 flex-shrink-0 sticky top-0 h-screen p-5" style={{ background: "var(--cs-card)", borderRight: "1px solid var(--cs-border)" }}>
        <Logo size="sm" />
        <p className="text-[11px] mt-1 mb-6" style={{ color: "var(--cs-fg2)" }}>Command Centre</p>
        <nav className="space-y-1 flex-1">
          {NAV.map((n) => {
            const active = loc.pathname === n.to;
            return (
              <button key={n.to} data-testid={`leader-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => nav(n.to)}
                className="cs-tap w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold text-left"
                style={{ background: active ? "rgba(224,26,79,0.15)" : "transparent", color: active ? "var(--cs-magenta)" : "var(--cs-fg2)" }}>
                <n.icon size={19} /> {n.label}
              </button>
            );
          })}
        </nav>
        <button data-testid="leader-logout" onClick={() => { logout(); nav("/"); }} className="cs-tap flex items-center gap-2 text-sm px-3 py-2" style={{ color: "var(--cs-red)" }}>
          <LogOut size={18} /> Sign out
        </button>
      </aside>

      <div className="flex-1 min-w-0">
        {/* mobile top nav */}
        <div className="lg:hidden sticky top-0 z-30 flex items-center gap-3 overflow-x-auto no-scrollbar px-4 py-3" style={{ background: "var(--cs-card)", borderBottom: "1px solid var(--cs-border)" }}>
          {NAV.map((n) => {
            const active = loc.pathname === n.to;
            return (
              <button key={n.to} onClick={() => nav(n.to)} className="cs-tap flex-shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full"
                style={{ background: active ? "var(--cs-magenta)" : "var(--cs-card-hi)", color: "#fff" }}>{n.label}</button>
            );
          })}
        </div>

        {!online && (
          <div className="flex items-center justify-center gap-2 py-2 text-xs font-semibold" style={{ background: "var(--cs-amber)", color: "#000" }}>
            <WifiOff size={14} /> You're offline. Live services temporarily unavailable.
          </div>
        )}

        <main className="p-5 lg:p-8 max-w-6xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
